// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fv","advertDetailContactGroup__header":"c-n_fw","advertDetailContactGroup__value":"c-n_fx"};